import { render, staticRenderFns } from "./ExportButton.vue?vue&type=template&id=923afe4a&scoped=true"
import script from "./ExportButton.vue?vue&type=script&lang=js"
export * from "./ExportButton.vue?vue&type=script&lang=js"
import style0 from "./ExportButton.vue?vue&type=style&index=0&id=923afe4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923afe4a",
  null
  
)

export default component.exports